import { CounterpartyType, type BaseStoredPaymentMethod } from '@carvia/ros-client-types';

type BookingParties = {
  customer?: { id: string } | null;
  agency?: { id: string } | null;
};

/**
 * Resolves whose stored payment method this is. A stored method keeps the id of the account it was
 * saved for, so once the customer account has been deleted (`customer` is null, not just unloaded),
 * every method that is not the agency's belongs to the customer.
 */
export function findStoredPaymentMethodCounterparty(
  booking: BookingParties,
  { userId }: Pick<BaseStoredPaymentMethod, 'userId'>,
): CounterpartyType.CUSTOMER | CounterpartyType.AGENCY | undefined {
  if (!userId) return undefined;
  if (booking.agency?.id === userId) return CounterpartyType.AGENCY;
  if (booking.customer === null || booking.customer?.id === userId) {
    return CounterpartyType.CUSTOMER;
  }
  return undefined;
}
